/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import i18n from 'i18n-js';

import TouchableElement from '@components/common/touchableElement';
import { font } from '@styles/fonts';
import { scale } from '@components/frame';
import { getBoxShadowStyle } from '@styles/shadow';
import { SmallLoading } from '@components/loading';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

export default ({
  onPress,
  height = 42,
  loading,
  text,
  color,
  C,
  borderBottom = false,
  shadow = true,
  borderRadiusTop = true,
  borderRadiusBottom = true,
  bg = 'Background / Light / Field',
  font: customFont,
}) => {
  const shadowStyle = getBoxShadowStyle({ type: 'Field', C });

  return (
    <View
      style={[
        { height: scale(height), userSelect: 'none' },
        borderBottom && {
          borderBottomColor: C('Hairline/Light/No trans'),
          borderBottomWidth: StyleSheet.hairlineWidth,
        },
      ]}
    >
      <TouchableElement onPress={onPress} hitSlop={{ top: 0, bottom: 0, left: 0, right: 0 }}>
        {({ boxStyle, pressHoverColor }) => (
          <View
            style={[
              shadow && shadowStyle,
              {
                backgroundColor: C(pressHoverColor(bg)),
                height: '100%',
                width: '100%',
                justifyContent: 'center',
                alignContent: 'center',
              },
              borderRadiusTop && {
                borderTopLeftRadius: scale(SCREEN_BORDER_RADIUS),
                borderTopRightRadius: scale(SCREEN_BORDER_RADIUS),
              },
              borderRadiusBottom && {
                borderBottomLeftRadius: scale(SCREEN_BORDER_RADIUS),
                borderBottomRightRadius: scale(SCREEN_BORDER_RADIUS),
              },
              boxStyle,
            ]}
          >
            {loading ? (
              <SmallLoading />
            ) : (
              <Text
                style={[
                  {
                    color: C(pressHoverColor(color)),
                    textAlign: 'center',
                  },
                  font[customFont || 'Body'],
                ]}
              >
                {i18n.t(text)}
              </Text>
            )}
          </View>
        )}
      </TouchableElement>
    </View>
  );
};
